import $ from 'jquery';
import ScrollReveal from 'scrollreveal';

class Reveal {
    constructor() {
        this.initReveal();
    }

    initReveal() {
        const sr = ScrollReveal();
        sr.reveal('.reveal', {
            reset: false,
            delay: 100,
            distance: '15px',
            scale: 1,
            duration: 300,
            viewFactor: 0.2,
            mobile: false,
        });

        if ($('.reveal-delay').length > 0) {
            sr.reveal('.reveal-delay', {
                reset: false,
                delay: 200,
                distance: '15px',
                scale: 1,
                duration: 300,
                viewFactor: 0.2,
                mobile: false,
            });
        }
    }

    static init() {
        if ($('.reveal').length > 0) {
            new Reveal();
        }
    }
}

export default Reveal;
